<template>
  <div>
    <div class="batch-add-monitor-item" v-if="isShowcompanyName" @click.stop>
      <div class="error-data" v-if="companyNameText">{{companyNameData}}
        <img class="icon" src="../../assets/img/faining.svg" v-if="isShowErrorIcon">
        <img class="icon" src="../../assets/img/success.svg" v-if="isShowSuccessIcon">
      </div>
      <el-input v-model="companyNameData" class="" v-if="companyNameInput" @input="selectCompanyName" @focus="companyNameInputFacus"></el-input>
      <div class="edit click-icon" @click="onEditClick"><img class="edit-icon" src="../../assets/img/edit.svg"></div>
      <div class="delete click-icon" @click="onDeleteClick()"><img class="delete-icon" src="../../assets/img/delete1.svg"></div>
      <div class="recommend-companies" v-if="companyNameInputList && recommendWordList.length">
        <div class="header-title">您可能想找</div>
        <ul class="recommend-companies-list">
          <li class="recommend-companie-name" v-for="(item, index) in recommendWordList" :key="index" @click="onRecommendCompanie(item)">
            <span class="item-value">{{item}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      indexData: -1,
      oldCompanyNameData: '',
      companyNameData: '',
      companyNameText: true,
      companyNameInput: false,
      companyNameInputList: false,
      isShowcompanyName: true,
      isShowErrorIcon: true,
      isShowSuccessIcon: false,
      recommendWordList: []
    };
  },
  props: {
    companyName: {
      type: String
    },
    recommendCompanies: {
      type: Array
    },
    showCompanyNameInput: {
      type: Boolean
    },
    index: {
      type: Number
    }
  },
  watch: {
    index(val) {
      this.indexData = val;
    },
    companyName(val) {
      this.companyNameData = val;
    },
    showCompanyNameInput(val) {
      this.companyNameInput = val;
      this.companyNameInputList = val;
      if (this.companyNameInput) {
        this.companyNameText = false;
      } else {
        this.companyNameText = true;
      }
    }
  },
  methods: {
    companyNameInputFacus() {
      this.companyNameInputList = true;
    },
    companyNameInputBlur() {
      this.companyNameText = true;
      this.companyNameInput = false;
      this.companyNameInputList = false;
    },
    selectCompanyName() {
      QuestionQuery.searchTermsRecommend(this.companyNameData).then(res => {
        this.recommendWordList = res.recommendWord;
      });
    },
    onEditClick() {
      this.companyNameText = !this.companyNameText;
      this.companyNameInput = !this.companyNameInput;
      this.companyNameInputList = !this.companyNameInputList;
      this.$emit('changeInput', { companyNameData: this.companyNameData, indexData: this.indexData });
    },
    onRecommendCompanie(res) {
      this.companyNameData = res;
      this.companyNameText = true;
      this.companyNameInput = false;
      this.companyNameInputList = false;
      this.isShowErrorIcon = false;
      this.isShowSuccessIcon = true;
      this.$emit('change', { companyNameData: this.companyNameData, oldCompanyNameData: this.oldCompanyNameData });
      this.oldCompanyNameData = this.companyNameData;
    },
    onDeleteClick() {
      this.$emit('deleteCompany', { res: this.companyNameData, isShowErrorIcon: this.isShowErrorIcon });
      this.isShowcompanyName = false;
    }
  },
  mounted() {
    this.indexData = this.index;
    this.companyNameData = this.companyName;
    this.recommendWordList = this.recommendCompanies;
    this.companyNameInput = this.showCompanyNameInput;
    this.companyNameInputList = this.showCompanyNameInput;
    document.addEventListener('click', this.companyNameInputBlur);
  },
  beforeDestroy() {
    // un-register events
    if (this.companyNameInputList) {
      this.companyNameInputBlur();
    }
    document.removeEventListener('click', this.companyNameInputBlur);
  }
};
</script>

<style lang="scss" scoped>
  .batch-add-monitor-item {
    position: relative;
    width: 496px;
    height: 44px;
    margin-bottom: 4px;
  }
  .error-data {
    position: relative;
    display: inline-block;
    width: 406px;
    height: 44px;
    padding: 12px 16px;
    background-color: #3e3c42;
    border-radius: 4px;
    
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    vertical-align: middle;
    .icon {
      position: absolute;
      top: 14px;
      right: 18px;
      width: 16px;
      height: 16px;
    }
  }
  .click-icon {
    display: inline-block;
    margin-left: 1px;
    width: 44px;
    height: 44px;
    padding: 15px;
    background-color: #3e3c42;
    vertical-align: middle;
    cursor: pointer;
  }
  .edit {
    .edit-icon {
      width: 14px;
      height: 14px;
    }
  }
  .delete {
    .delete-icon {
      width: 16px;
      height: 16px;
    }
  }
  .recommend-companies {
    position: absolute;
    top: 40px;
    width: 406px;
    padding: 8px 16px 14px;
    border-radius: 4px;
    background-color: #17171b;
    font-size: 14px;
    color: #ffffff;
    z-index: 1;
    .recommend-companies-list {
      margin: 4px 0;
      padding: 0;
      list-style: none;
    }
    .header-title {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.4);
    }
    .recommend-companie-name {
      cursor: pointer;
      .item-value {
        display: inline-block;
        max-width: 396px;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .el-input {
    width: 406px;
  }
  /deep/ {
    .el-input .el-input__inner {
    border: none;
    color: #ffffff;
    background-color: #27252a !important;
    &:focus {
      border: solid 1px #45a8cc;
    }
  }
  }
</style>

